import { HStack, VStack } from "@gluestack-ui/themed";
import { TransactionsController } from "./controller";
import { HeaderStyleEnum } from "@repo/core/components/layout/CustomHeader/types";
import { ScrollView } from "@repo/core/components/layout/ScrollView";
import { TransactionGroup } from "@repo/core/components/layout/TransactionGroup";
import { filterStatusOptions } from "./consts";
import { ButtonGroup } from "@repo/core/components/core/ButtonGroup";
// import { InputDatePicker } from "@repo/core/components/core/InputDatePicker";
import { EmptyState } from "@repo/core/components/layout/EmptyState";
import { TransactionsLoading } from "./loading";
import { GroupedTransactionStatusEnum } from "@repo/core/constants/transactions";
import Scaffolds from "@repo/core/components/layout/Scaffolds";
import { StoreSelectBarVariantEnum } from "@repo/core/components/layout/Scaffolds/StoreSelectScaffold/types";

function Transactions() {
  const {
    transactions,
    handleSelectStatus,
    transactionsIsLoading,
    filterByStatus
  } = TransactionsController();

  return (
    <Scaffolds.Root showHeader={false}>
      <Scaffolds.StoreSelect
        title="Transações do dia"
        type={HeaderStyleEnum.primary}
        // Remove default border from header
        mb="$0"
        showConfirmStoreModal
        selectStoreBarVariant={StoreSelectBarVariantEnum.GREEN}
      >
        <VStack
          $md-alignItems="center"
          justifyContent="center"
          $web-pt="$4"
          py="$4"
          pb="$4"
          space="lg"
          bg="$primary700"
          zIndex={2}
        >
          {/*
          // NOTE: Awaiting implement date filter on api
          // <HStack $md-w="60%" $xl-w="35%" space="lg" justifyContent="center">
          //   <InputDatePicker
          //     label="De"
          //     onChangeDate={(date) => filterStartDate(date)}
          //     defaultValue={startDate}
          //   />
          //   <InputDatePicker
          //     label="Até"
          //     onChangeDate={(date) => filterEndDate(date)}
          //     defaultValue={endDate}
          //   />
          // </HStack>
          // */}
          <HStack height="$10">
            <ScrollView horizontal showsHorizontalScrollIndicator={false}>
              <ButtonGroup
                type="primary"
                onChange={(value) =>
                  handleSelectStatus(value as GroupedTransactionStatusEnum)
                }
                options={filterStatusOptions}
                value={filterByStatus}
              />
            </ScrollView>
          </HStack>
        </VStack>
        <VStack flex={1} justifyContent="center">
          {transactions?.length ? (
            !transactionsIsLoading ? (
              <ScrollView contentContainerStyle={{ padding: 16, flex: 0 }}>
                {transactions.map((transactionGroup, index) => (
                  <TransactionGroup
                    key={index}
                    date={transactionGroup.date}
                    items={transactionGroup.transactions}
                  />
                ))}
              </ScrollView>
            ) : (
              <ScrollView contentContainerStyle={{ padding: 16, flex: 0 }}>
                <TransactionsLoading />
              </ScrollView>
            )
          ) : (
            <EmptyState text="Nenhuma transação para mostrar." />
          )}
        </VStack>
      </Scaffolds.StoreSelect>
    </Scaffolds.Root>
  );
}

export default Transactions;
